var _animateTransform, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,17 C13.418278,17 17,13.418278 17,9 C17,4.581722 13.418278,1 9,1 C4.581722,1 1,4.581722 1,9 C1,13.418278 4.581722,17 9,17 L9,17 Z",
    stroke: "currentColor",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,9 C17,13.418278 13.418278,17 9,17",
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,13.5714286 C11.5247303,13.5714286 13.5714286,11.5247303 13.5714286,9 C13.5714286,6.47526972 11.5247303,4.42857143 9,4.42857143 C6.47526972,4.42857143 4.42857143,6.47526972 4.42857143,9 C4.42857143,11.5247303 6.47526972,13.5714286 9,13.5714286 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.47c72449996b58975aaf21836f040630.svg";
export { ForwardRef as ReactComponent };